
import React, { useState, useEffect } from 'react';
import { useEvents } from '@/hooks/useEvents';
import EventFilters from '@/components/events/EventFilters';
import EventGrid from '@/components/events/EventGrid';
import CreateEventButton from '@/components/events/CreateEventButton';
import { Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';
import { PageHeader } from '@/components/ui/page-header';
import { useAuth } from '@/contexts/AuthContext';



const Events: React.FC = () => {
  const { events, isLoading, filterOptions, updateFilters, isAdmin, registeredEvents, handleEventRegistration, refreshEvents } = useEvents();
  const [locations, setLocations] = useState<string[]>([]);
  const { user, subscription } = useAuth();
  

  useEffect(() => {
    // Extract unique locations from events
    if (events.length > 0) {
      const uniqueLocations = Array.from(
        new Set(
          events
            .map(event => event.location)
            .filter(location => location) as string[]
        )
      );
      setLocations(uniqueLocations);
    }
  }, [events]);

  const handleEventCreated = () => {
    refreshEvents();
  };


  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      
      <PageHeader 
        title="Événements NODE"
        description="Participez aux événements exclusifs de notre communauté tech"
      />
      
      <main className="flex-grow container mx-auto px-4 py-8 pb-24 space-y-6">
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            {/* Zone gauche : boutons créer et inviter */}
            <div className="flex items-center gap-3">
              {user && (
                <CreateEventButton onEventCreated={handleEventCreated} />
              )}
            </div>
            
            {/* Zone droite : informations et compteurs */}
            <div className="flex items-center gap-2 text-muted-foreground">
              <Calendar className="text-primary" />
              <span>
                {events.filter(e => e.status === 'upcoming').length} événements à venir
              </span>
            </div>
          </div>
          
          <EventFilters 
            filterOptions={filterOptions}
            updateFilters={updateFilters}
            locations={locations}
          />
          
          <EventGrid 
            events={events}
            isLoading={isLoading}
            onRegister={handleEventRegistration}
            registeredEvents={registeredEvents}
          />
        </div>
      </main>
      
      <Footer />
      
    </div>
  );
};

export default Events;
